import actionTypes from '../common/actionTypes';
import paymentAPI from './paymentAPI';
import * as toastr from 'toastr';

const paymentActions = {
	setStripe: (stripe: any) => {
		return { type: actionTypes.SET_STRIPE, stripe };
	},
	setPaymentDetails: (details: any) => {
		return { type: actionTypes.SET_PAYMENT_DETAILS, details };
	},
	createNewCustomerSubscription:
		(userId: number, policyId: string, tokenId: string,
			referralCode?: string, skipDeclineChecker?: boolean, resetPasswordUrl?: string) =>
		(dispatch: any) => {
			return paymentAPI
			.createNewCustomerSubscription(userId, policyId, tokenId, referralCode, skipDeclineChecker, resetPasswordUrl)
				.then(subscriptionResponse => {
					dispatch({ type: actionTypes.CREATE_SUBSCRIPTION, subscriptionResponse });
				})
				.catch(err => {
					if (err.responseStatus) {
						throw err.responseStatus.message;
					}
					throw err;
				});
		},
	fetchPayment: (invoiceNumber: string) => (dispatch: any) => {
		return paymentAPI.fetchPayment(invoiceNumber)
			.then(payment => {
				dispatch({ type: actionTypes.FETCH_CUSTOMER_PAYMENT, payment });
			})
			.catch(err => {
				if (err.responseStatus) {
					toastr.error(err.responseStatus.message);
				}
			});
	},
	fetchCustomerPayment: (userId: string, invoiceNumber: string) => (dispatch: any) => {
		return paymentAPI.fetchCustomerPayment(userId, invoiceNumber)
			.then(payment => {
				dispatch({ type: actionTypes.FETCH_CUSTOMER_PAYMENT, payment });
			})
			.catch(err => {
				if (err.responseStatus) {
					toastr.error(err.responseStatus.message);
				}
			});
	},
	fetchCustomerPayments: (userId: string) => (dispatch: any) => {
		return paymentAPI.fetchCustomerPayments(userId)
			.then(payments => {
				dispatch({ type: actionTypes.FETCH_CUSTOMER_PAYMENTS, payments });
			})
			.catch(err => {
				if (err.responseStatus) {
					toastr.error(err.responseStatus.message);
				}
			});
	},
	fetchCustomerUpcomingInvoice: (userId: string) => (dispatch: any) => {
		return paymentAPI.fetchCustomerUpcomingInvoice(userId)
			.then(invoice => {
				dispatch({ type: actionTypes.FETCH_CUSTOMER_UPCOMING_INVOICE, invoice });
			})
			.catch(err => {
				if (err.responseStatus) {
					toastr.error(err.responseStatus.message);
				}
			});
	},
	fetchCustomerCard: (userId: string) => (dispatch: any) => {
		return paymentAPI.fetchCustomerCard(userId)
			.then((card: StripeCard) => {
				dispatch({ type: actionTypes.FETCH_CUSTOMER_CARD, card });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchInvoiceCard: (invoiceId: string) => (dispatch: any) => {
		return paymentAPI.fetchInvoiceCard(invoiceId)
			.then((invoiceCard: StripeCard) => {
				dispatch({ type: actionTypes.FETCH_INVOICE_CARD, invoiceCard });
			})
			.catch(err => {
				throw err;
			});
	},
	payInvoice: (invoiceId: string, token?: stripe.Token, customerId?: string) => (dispatch: any) => {
		return paymentAPI.payInvoice(invoiceId, token, customerId)
			.then(paidInvoice => {
				dispatch({ type: actionTypes.PAY_INVOICE, invoice: paidInvoice });
				toastr.success('Payment successful!');
			})
			.catch(err => {
				if (err.responseStatus) {
					toastr.error(err.responseStatus.message);
				}
			});
	},
	updateCustomerCard: (customerId: string, token: stripe.Token) => (dispatch: any) => {
		return paymentAPI.updateCustomerCard(customerId, token)
			.then(updatedCustomerResponse => {
				dispatch({ type: actionTypes.UPDATE_CUSTOMER_CARD, user: updatedCustomerResponse });
			})
			.catch(err => {
				if (err.responseStatus) {
					toastr.error(err.responseStatus.message);
				}
			});
	},
	updateCustomerPlan: (policy: CustomerPolicy, overwriteRate: boolean) => (dispatch: any) => {
		return paymentAPI.updateCustomerPlan(policy, overwriteRate)
			.then(newPlan => {
				dispatch({ type: actionTypes.UPDATE_CUSTOMER_PLAN, customerPolicy: newPlan });
			})
			.catch(err => {
				if (err.responseStatus) {
					toastr.error(err.responseStatus.message);
				}
			});
	},
};

export default paymentActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/payment/paymentActions.ts